// @flow

import { map, path, prop, propOr } from "ramda";
import { createSelector } from "reselect";
import { type MedidaParaPersonalizar } from "../../model";
import { type State, getMedidasReferenciadasEmExpressoes } from "../../state";
import { lazyFind } from "../../util";

const geradorDeAliasesDeAtivos = function*(inicial = 0) {
  const alias = indice => {
    const alfabeto = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const letra = alfabeto.charAt(indice % 26);
    const concatenado = Math.floor(indice / alfabeto.length);
    return concatenado > 0 ? alias(concatenado - 1) + letra : letra;
  };

  while (true) yield `A${alias(inicial++)}`;
};

export const getMedidasParaPersonalizar = (
  state: State
): Array<MedidaParaPersonalizar> => state.medidasParaPersonalizar || [];

export const gerarAliasParaAtivo = (state: State): string => {
  const aliasesUsados = new Set(
    getMedidasParaPersonalizar(state)
      .filter(prop("ativo"))
      .map(prop("ativo"))
      .map(propOr(null, "alias"))
      .filter(Boolean)
  );

  const aliasDisponivel = lazyFind(
    alias => !aliasesUsados.has(alias),
    geradorDeAliasesDeAtivos()
  );

  // $FlowFixMe
  return aliasDisponivel;
};

const aliasMedidasReferenciados: Array<any> = createSelector(
  getMedidasParaPersonalizar,
  map(path(["medida", "alias"]))
);

export const getMedidasReferenciadasEmMedidasParaPersonalizar: Array<string> = createSelector(
  aliasMedidasReferenciados,
  aliases => new Set(aliases)
);

const getMedidasParaPersonalizarDesabilitadasDeEdicao = createSelector(
  getMedidasParaPersonalizar,
  getMedidasReferenciadasEmExpressoes,
  (medidasParaPersonalizar, medidasReferenciadas) =>
    medidasParaPersonalizar.filter(
      ({ medida, ativo }) =>
        (ativo === null && medidasReferenciadas.has(medida.alias)) ||
        (ativo !== null && medidasReferenciadas.has(ativo.alias))
    )
);

export const getIdMedidasParaPersonalizarDesabilitadasDeEdicao = createSelector(
  getMedidasParaPersonalizarDesabilitadasDeEdicao,
  medidas =>
    new Set(
      medidas
        .filter(
          medida => medida.medida.alias || (medida.ativo && medida.ativo.alias)
        )
        .map(medida => medida.id)
        .filter(Boolean)
    )
);
